import { render, staticRenderFns } from "./RegistroDeIncapacidades.vue?vue&type=template&id=4f5e731c&scoped=true"
import script from "./RegistroDeIncapacidades.vue?vue&type=script&lang=js"
export * from "./RegistroDeIncapacidades.vue?vue&type=script&lang=js"
import style0 from "./RegistroDeIncapacidades.vue?vue&type=style&index=0&id=4f5e731c&prod&scoped=true&lang=css"
import style1 from "./RegistroDeIncapacidades.vue?vue&type=style&index=1&id=4f5e731c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e731c",
  null
  
)

export default component.exports